export default __webpack_public_path__ + "static/media/jamJars.22ebf484.jpg";